export default "__VITE_ASSET__8bc53b11__"